import React from "react";
import "./Home.css";
import { Link } from "react-router-dom";
import { Image, Text, Title } from "../../components/ui";

// image
import Logo from "../../assets/images/logo.png";

// icons
import { BsFillCircleFill } from "react-icons/bs";
import { SlArrowRight } from "react-icons/sl";
import { TbCloudUpload, TbEdit, TbTrash } from "react-icons/tb";
import { Flex, SafeArea } from "../../components/layout";

function Home() {
  const links = [
    {
      name: "ateliers",
      links: [
        {
          title: "Ajouter un atelier",
          text: "Ajouter un atelier et ses informations relatifs",
          url: "/workshops/add",
          Icon: TbCloudUpload,
        },
        {
          title: "Modifier, supprimer vos ateliers",
          text: "Ajouter une description ou des tags ou alors supprimer l'atelier",
          url: "/workshops/manage",
          Icon: TbEdit,
        },
      ],
    },
    {
      name: "partenaires",
      links: [
        {
          title: "Ajouter d'un partenaire",
          text: "Ajouter un partenaire et ses informations utilisé dans les articles",
          url: "/partners/add",
          Icon: TbCloudUpload,
        },
        {
          title: "Modifier, supprimer vos partenaires",
          text: "Ajouter une description ou des tags ou alors supprimer le partenaire",
          url: "/partners/manage",
          Icon: TbEdit,
        },
      ],
    },
    {
      name: "Calendrier",
      links: [
        {
          title: "Ajouter un événement",
          text: "Ajouter un événement et ses informations relatifs",
          url: "/calendar/add",
          Icon: TbCloudUpload,
        },
        {
          title: "Modifier, supprimer vos événements",
          text: "Ajouter une description ou des tags ou alors supprimer l'événement",
          url: "/calendar/manage",
          Icon: TbEdit,
        },
      ],
    },
    {
      name: "photos",
      links: [
        {
          title: "Ajouter une photo",
          text: "Ajouter une photo ou plusieurs photos",
          url: "/photos/add",
          Icon: TbCloudUpload,
        },
        {
          title: "Supprimer vos photos",
          text: "Supprimer une photo ou plusieurs photos",
          url: "/photos/manage",
          Icon: TbTrash,
        },
      ],
    },
  ];
  return (
    <SafeArea className="Home">
      <Flex type="col" gap={50}>
        <Title level="h2">Administration</Title>
        <Flex type="col" gap={50}>
          <Flex type="between-center">
            <Flex gap={20}>
              <Image src={Logo} alt="" className="logo" />
              <Flex type="col">
                <Text>L'Ecrin Sauvage</Text>
                <Text size="xs">www.lecrin-sauvage.fr</Text>
              </Flex>
            </Flex>
            <Flex className="success" gap={10}>
              <BsFillCircleFill className="icon" />{" "}
              <Text size="xs" bold="semi-bold">
                EN LIGNE
              </Text>
            </Flex>
          </Flex>
          {links.map((link, index) => (
            <Flex key={index} type="col" className="group" gap={10}>
              <Text size="xs" className="group-title" bold="semi-bold">
                {link.name}
              </Text>
              {link.links.map((l, index) => (
                <Link key={index} to={l.url} className="container">
                  <Flex type="between-center">
                    <Flex gap={20}>
                      <l.Icon size={20} />
                      <Flex type="col">
                        <Text>{l.title}</Text>
                        <Text size="xs">{l.text}</Text>
                      </Flex>
                    </Flex>
                    <SlArrowRight className="icon" />
                  </Flex>
                </Link>
              ))}
            </Flex>
          ))}
        </Flex>
      </Flex>
    </SafeArea>
  );
}

export default Home;
